import { render, staticRenderFns } from "./LiveAlerts.vue?vue&type=template&id=f69e9358&scoped=true"
import script from "./LiveAlerts.vue?vue&type=script&lang=js"
export * from "./LiveAlerts.vue?vue&type=script&lang=js"
import style0 from "./LiveAlerts.vue?vue&type=style&index=0&id=f69e9358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69e9358",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
